export function calcIsLowRes(height: number, width: number, minHeight: number, minWidth: number) {
  return calcResolutionStatus(height, width, minHeight, minWidth, 0.5) === 'very-low';
}

export function calcResolutionStatus(
  height: number,
  width: number,
  minHeight: number,
  minWidth: number,
  threshold: number
) {
  console.log('height', height);
  console.log('width', width);
  console.log('minHeight', minHeight);
  console.log('minWidth', minWidth);

  if (
    Math.max(height, width) < Math.max(minHeight, minWidth) ||
    Math.min(height, width) < Math.min(minHeight, minWidth)
  ) {
    if (
      Math.max(height, width) < Math.ceil(Math.max(minHeight, minWidth) * threshold) ||
      Math.min(height, width) < Math.ceil(Math.min(minHeight, minWidth) * threshold)
    ) {
      return 'very-low';
    }
    return 'low';
  }
  return 'ok';
}
